export { P404Component } from '../components/pages/error/p404.component';
export { P500Component } from '../components/pages/error/p500.component';
